import {Component, OnInit} from '@angular/core';
import {AuthService} from '@app/auth/services';
import {getPageRoute} from "../../../../utils/helpers";

@Component({
  selector: 'app-external-redirect',
  template: '',
})
export class ExternalRedirectComponent implements OnInit {
  constructor(private _AuthService: AuthService) {
  }

  ngOnInit() {
    const pageRoute = getPageRoute().replace("/", "");
    this._AuthService.redirectToNewPersonal(pageRoute);
  }
}
